import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const FullWidthCTABase = styled.div`
  background-color: ${theme.colors.darkBlues[5]};
  display: flex;
  align-items: center;
  padding: 72px 12%;
  flex-direction: row;
  justify-content: center;
  height: 200px;
  ${theme.largerThan.sm} {
    flex-direction: row;
  }

  ${theme.largerThan.xl} {
    padding: 48px 25%;
  }
`;

export const Image = styled.img`
  height: 198px;
  max-width: 200px;
  border-radius: 5px;
  margin: 0 0 28px 0;
  object-fit: cover;

  ${theme.largerThan.sm} {
    margin: 0 24px 0 0;
  }
  ${theme.smallerThan.md} {
    display: none;
  }
`;

export const UploadContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  color: ${theme.colors.darkBlues[100]};
  height: 100%;
  min-width: 500px;
  ${theme.largerThan.sm} {
    text-align: initial;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  color: ${theme.colors.darkBlues[100]};
  height: 100%;

  ${theme.largerThan.sm} {
    text-align: initial;
  }
`;

export const Heading = styled.h3`
  color: ${theme.colors.darkBlues[100]};
  margin: 0 0 28px 0;

  ${theme.largerThan.sm} {
    margin: 0 0 32px 0;
  }
`;

export const QuoteCTATitle = styled.h3`
  margin: 0;
  text-align: center;
  padding: 0 16px;
  font-size: 16px;
  font-weight: ${theme.fontWeights.semibold};
  letter-spacing: 0;
  line-height: ${theme.leading.normal};
  color: ${theme.colors.darkBlues[75]};
  ${theme.smallerThan.md} {
    padding: 0 8px;
  }
  ${theme.smallerThan.sm} {
    font-size: ${theme.fontSizes[1]};
    padding: 0;
  }
`;

export const QuoteCTABackground = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 0px;
  padding-bottom: 0px;

  ${theme.smallerThan.sm} {
    gap: 10px;
  }
`;
